import { useEffect, useState } from "react";
import { FormikProvider, useFormik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import allowNumbersOnly from "../../CommonUtils/CommonValidations";
// import allowNumbersOnly from "../../CommonUtils/CommonValidations";

export default function ReallocatedStudents() {
  const [studentsData, setStudentsData] = useState(false);
  const [crseData, setCrseData] = useState(false);

  // ✅ VALIDATION
  const validation = Yup.object().shape({
    reallocatedStudentsDetails: Yup.array().of(
      Yup.object().shape({
        firstyear: Yup.string().required("Required"),
        secYear: Yup.string().required("Required"),
        thirdYear: Yup.string().required("Required"),
      }),
    ),
  });

  // ✅ FORMIK
  const reallocatedStudents = useFormik({
    initialValues: {
      reallocatedStudentsDetails: [],
    },
    validationSchema: validation,

    onSubmit: (values) => {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to Save ?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
      }).then((result) => {
        if (result.isConfirmed) {
          const payload = {
            studentsDetails: values.reallocatedStudentsDetails.map((item) => ({
              courseId: item.courseId,
              firstYearStudents: parseInt(item.firstyear || 0),
              secYearStudents: parseInt(item.secYear || 0),
              thirdYearStudents: parseInt(item.thirdYear || 0),
            })),
          };

          const url = `${config.url.FAC_URL}saveStudentsDetails`;

          CommonAxiosPost(url, payload)
            .then((res) => {
              if (res?.data?.scode === "01") {
                Swal.fire({
                  title: res.data.sdesc || "Saved!",
                  icon: "success",
                }).then(() => {
                  LoadData();
                });
              } else {
                Swal.fire({
                  text: res.data?.sdesc || "Failed to save details",
                  icon: "warning",
                });
              }
            })
            .catch((err) => {
              console.error(err);

              Swal.fire({
                text: "Error while saving.",
                icon: "error",
              });
            });
        }
      });
    },
  });

  // ✅ LOAD COURSES
  function LoadData() {
    // -------- COURSE DATA --------
    let courseUrl = config.url.FAC_URL + `getCourseIntakeList`;

    CommonAxiosGet(courseUrl).then((courseRes) => {
      let courseList = [];

      if (courseRes?.data?.scode === "01") {
        setCrseData(true);
        courseList = courseRes?.data?.list || [];
      }

      // -------- STUDENTS DATA --------
      let studentsUrl = config.url.FAC_URL + `getStudentsDetails`;

      CommonAxiosGet(studentsUrl).then((studentsRes) => {
        let studentsList = [];

        if (studentsRes?.data?.scode === "01") {
          setStudentsData(true);
          studentsList = studentsRes?.data?.data || [];
        }

        // -------- MERGE DATA --------
        const mappedRows = courseList.map((course) => {
          const existingStudent = studentsList.find(
            (s) => s.course_id === course.course_id,
          );

          return {
            courseId: course.course_id,
            courseName: course.course_name,
            courseCatId: course.course_cat_id,
            courseCatName: course.course_cat_name,
            courseGroupCode: course.course_group_code,
            courseGroupName: course.course_group_desc,
            firstyear: existingStudent
              ? existingStudent.first_year_students
              : "",
            secYear: existingStudent ? existingStudent.sec_year_students : "",
            thirdYear: existingStudent
              ? existingStudent.third_year_students
              : "",
          };
        });

        // -------- SET FORMIK --------
        reallocatedStudents.setFieldValue(
          "reallocatedStudentsDetails",
          mappedRows,
        );
      });
    });
  }

  // ✅ LOAD ON START
  useEffect(() => {
    LoadData();
  }, []);

  return (
    <div className="faculty-form-wrapper">
      <div className="faculty-card">
        <h5 className="mb-3 innerheader-new">
          <span>Number of students to be re-allocated</span>
        </h5>

        <FormikProvider value={reallocatedStudents}>
          <Form
            onSubmit={reallocatedStudents.handleSubmit}
            className="affl-form"
          >
            {crseData ? (
              <>
                <div className="table-responsive mt-3">
                  <table className="table table-bordered mt-2">
                    <thead className="table-primary">
                      <tr>
                        <th rowSpan="2">S.No</th>

                        <th rowSpan="2">
                          {" "}
                          Academic Program Type{" "}
                        </th>
                        <th rowSpan="2">Course / Program </th>
                        <th rowSpan="2"> Course / Branch </th>

                        <th colSpan="3" className="text-center">
                          No. of Students to be re-allocated
                        </th>
                      </tr>

                      <tr>
                        <th>1st Year</th>
                        <th>2nd Year</th>
                        <th>3rd Year</th>
                      </tr>
                    </thead>

                    <tbody>
                      {reallocatedStudents.values.reallocatedStudentsDetails?.map(
                        (row, index) => (
                          <tr key={index}>
                            {/* SNO */}
                            <td>{index + 1}</td>
                            <td>
                              {row.courseGroupName}
                              <Field
                                type="hidden"
                                name={`labDetails[${index}].courseGroupCode`}
                              />
                              <Field
                                type="hidden"
                                name={`labDetails[${index}].courseGroupName`}
                              />
                            </td>
                            <td>
                              {row.courseCatName}
                              <Field
                                type="hidden"
                                name={`labDetails[${index}].courseCatId`}
                              />
                              <Field
                                type="hidden"
                                name={`labDetails[${index}].courseCatName`}
                              />
                            </td>
                            {/* COURSE NAME */}
                            <td>
                              {row.courseName}

                              <Field
                                type="hidden"
                                name={`reallocatedStudentsDetails.${index}.courseId`}
                              />
                            </td>

                            {/* 1st Year */}
                            <td>
                              <Field
                                name={`reallocatedStudentsDetails.${index}.firstyear`}
                                className="form-control"
                                maxLength="3"
                                onKeyPress={(e) => allowNumbersOnly(e)}
                                disabled={studentsData}
                              />

                              <ErrorMessage
                                name={`reallocatedStudentsDetails.${index}.firstyear`}
                                component="div"
                                className="text-danger"
                              />
                            </td>

                            {/* 2nd Year */}
                            <td>
                              <Field
                                name={`reallocatedStudentsDetails.${index}.secYear`}
                                className="form-control"
                                maxLength="3"
                                onKeyPress={(e) => allowNumbersOnly(e)}
                                disabled={studentsData}
                              />

                              <ErrorMessage
                                name={`reallocatedStudentsDetails.${index}.secYear`}
                                component="div"
                                className="text-danger"
                              />
                            </td>

                            {/* 3rd Year */}
                            <td>
                              <Field
                                name={`reallocatedStudentsDetails.${index}.thirdYear`}
                                className="form-control"
                                maxLength="3"
                                onKeyPress={(e) => allowNumbersOnly(e)}
                                disabled={studentsData}
                              />

                              <ErrorMessage
                                name={`reallocatedStudentsDetails.${index}.thirdYear`}
                                component="div"
                                className="text-danger"
                              />
                            </td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="mt-3">
                  <div className="fw-bold text-danger fs-6">Note:</div>

                  <ul style={{ listStyleType: "square", marginLeft: "20px" }}>
                    <li className="mt-2">
                      If progressive Closure mention <b>NIL</b>
                    </li>

                    <li className="mt-2">
                      Willingness/consent of the students on-roll (if any) of
                      the institute for their transfer to another institute(s)
                      shall be annexed
                    </li>
                  </ul>
                </div>

                {!studentsData ? (
                  <button
                    type="submit"
                    className="btn btn-primary float-end mt-3"
                  >
                    Submit
                  </button>
                ) : (
                  <div className="d-flex justify-content-end mt-4">
                    <span className="text-success fw-bold">
                      Already Submitted
                    </span>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center text-danger fw-bold fs-6">
                **** No Data Found ****
              </div>
            )}
          </Form>
        </FormikProvider>
      </div>
    </div>
  );
}
